// A rename commits at most once per edit. Escape cancels it, and Enter commits
// it; in both cases the input then unmounts and may fire a blur, which must
// not commit again (a cancelled edit would be saved, or a rename sent twice).
// start() re-arms it for the next edit.
export const createRenameGuard = () => {
  let settled = false;
  return {
    start: () => {
      settled = false;
    },
    cancel: () => {
      settled = true;
    },
    shouldCommit: () => !settled,
    committed: () => {
      settled = true;
    },
  };
};
